<div class="loader-container" *ngIf="isLoading">
	<div class="loader"></div>
  </div>
  <div class="add-app-button" *ngIf="topicId">
	<!-- <span mat-button (click)="isAppBtns = true">
	  <i class="fa fa-plus-square cursor"></i>
	</span> -->
  
	<!-- <mat-menu #menu2="matMenu">
				<button mat-menu-item (click)="addApp('image')" >Image app</button>
				<button mat-menu-item (click)="addApp('video')" >Video app</button>
				<button mat-menu-item (click)="addApp('text')" >Text app</button>
				<button mat-menu-item (click)="addApp('zip')" >Zip app</button>
			  </mat-menu> -->
  </div>
  <div class="app-btns-container" *ngIf="apps.length == 0 && topicId && !isLoading && user.roles !=='student'">
	<div class="row app-btns-row">
	  <div class="col">
		
		<button class="app-button"data-toggle="modal" data-target="#app-model" (click)="addApp('image')"> <span  class="mr-2"><i class="fas fa-images fa-xl"></i></span> <span>Image app</span></button>
	  </div>
	  <div class="col">
		
		<button class="app-button"data-toggle="modal" data-target="#app-model" (click)="addApp('video')"><span class="mr-2"><i class="fas fa-file-video fa-xl"></i></span> <span>Video app</span> </button>
  
	  </div>
	  <div class="col">
		
		<button class="app-button"data-toggle="modal" data-target="#app-model" (click)="addApp('text')"><span  class="mr-2"><i class="fas fa-file-signature fa-xl"></i></span> <span>Text app</span> </button>
	  </div>
	</div>
  
  </div>
  <div class="app-btns-container" *ngIf="apps.length == 0 && topicId && !isLoading && user.roles =='student'">
	Data not found!
  </div>
  <div class="search-container" *ngIf="topicId && !isReadMode && !isLoading && user.roles !=='student'">
	<div class="search-type-select">
	  <ng-select style=" z-index: 1; " [items]="['All', 'Video', 'Image', 'Text']" [searchable]="false"
		[clearable]="false" [(ngModel)]="selectedItem"></ng-select>
	</div>
	<input type="text" placeholder="Search Apps" [(ngModel)]="searchValue" class="search-input">
	<button class="search-button" (click)="searchApp(searchValue)"><img src="assets/search_icon.svg"></button>
  </div>
  
  <div class="search-container" *ngIf="topicId && isReadMode && !isLoading ">
	<!-- <input type="text" placeholder="Search Apps" [(ngModel)]="searchValue" class="search-input"> -->
	<!-- <input type="text" class="form-control" placeholder="Search" [formControl]="searchForm.get('searchInput')"
	[ngbTypeahead]="searchItems" [resultFormatter]="formatItem" [(ngModel)]="selected"> -->
	<div class="form-group">
	  <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchTerm">
	  
	  <div class="list-group mt-2" *ngIf="filteredItems$.length > 0">
		<a class="list-group-item list-group-item-action" *ngFor="let item of filteredItems$" (click)="selectItem(item?.name)">
		  {{ item.name }}
		</a>
	  </div>
	</div>
	
  
	<button class="search-button"><img src="assets/search_icon.svg"></button>
  </div>
  
  <div class="app-view-container container" *ngIf="!isLoading">
  
	<div class="app-section" *ngFor="let app of apps">
	  <div class="col d-flex align-items-center">
		<h4  class="app-title-h4">
		  {{app?.title}}
		</h4> 
		<div class="col d-flex justify-content-end my-2 submit-btn">
		  <button *ngIf="isSubmitted !==true && user.roles ==='student' && app?.app_tag[0]?.displayname === 'Assignment'" class="btn btn-outline-primary" (click)="openModalForAssignment(myModalContent,user.id,app?._id,courseId,topicId)">Submit</button>
		</div>
		
	  </div>
	  <div *ngIf="app?.type === 'image'">
		<!-- Display image content -->
		<img width="100%" [src]="s3MediaUrl+app?.content" alt="Image" />
	  </div>
	  <div *ngIf="app?.type === 'video'&&!app.isurl_link">
		<!-- Display video content -->
		<video width="100%" [src]="s3MediaUrl+app?.content" controls></video>
	  </div>
	  <div *ngIf="app?.type === 'video'&&app.isurl_link ">
		<!-- Display video content -->
		<div [innerHTML]="app.isurl_link | safeHtml"></div>
		 <!-- {{formatHtmlapp?.url_link }} -->
	  </div>
	  <div *ngIf="app?.type === 'text'">
		<!-- Display markdown text content -->
		<div [innerHTML]="app?.content | safeHtml"></div>
	  </div>
	  <div [hidden]="isReadMode" *ngIf="user.roles === 'admin'">
		<i [ngClass]="isConnected(app?._id)?'fa fa-x cursor':'fa fa-link cursor'" title="Disconnect app"
		(click)="connectDisconnect(app?._id)"></i>
		<i class="fa fa-edit cursor ml-2" data-toggle="modal" data-target="#app-model" (click)="editApp(app)"></i>
		</div>
  
		<div class="row p-2" *ngIf=" user.roles !=='student'">
		  <div class="btn btn-outline-primary ml-2" *ngFor="let resource of app.resources">
			<a [href]="s3MediaUrl+resource.documents" target="_blank">{{resource.content}}</a>
			<i class="fa fa-x cursor danger font-large float-right" (click)="resourceDelete(app?._id,resource._id)"></i>
		  </div>
		  <!-- <div class="col-xl-3 col-lg-6 col-12" *ngFor="let resource of app.resources">
			<div class="card">
			  <div class="card-content">
				<div class="card-body">
				  <div class="media">
					<div class="media-body text-left">
					  <h3 class="mb-1 danger">{{resource}}</h3>
					  <span></span>
					</div>
					<div class="media-right align-self-center">
					  <i class="fa fa-x cursor danger font-large-1 float-right"></i>
					</div>
				  </div>
				</div>
			  </div>
			</div>
		  </div> -->
		</div>
  
	</div>
  </div>
  <!-- <div class="video-container">
	<video width="100%" height="100%" controls>
	  <source src="myvideo.mp4" type="video/mp4">
	  Your browser does not support the video tag.
	</video>
	<div class="video-controls">
	  <i class="icon-volume-up"></i>
	</div>
  </div> -->
  <app-lms-new-content-editior #modalRef [appType]="appType" (closeModal)="closeModel()" [selectedApp]="selectedApp"
	[courseId]="courseId" [topicId]="appsByTopic?.length ? null : topicId"></app-lms-new-content-editior>
  
  <!------------- Assignment Popup --------------------------------------->
  <div>
	<ng-template #myModalContent>
	  <div class="modal-header">
		<h4 class="modal-title">Assignment</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="form-group">
		  <label>Description</label>
		  <textarea class="form-control" [(ngModel)]="assignment_model.notes" [ngModelOptions]="{standalone: true}" placeholder="Enter description" name="notes" id="notes" cols="30" rows="2"></textarea>
		</div>
		<div class="form-group">
		  <label>Teacher Notes</label>
		  <textarea class="form-control" [(ngModel)]="assignment_model.admin_notes" [ngModelOptions]="{standalone: true}" name="admin_notes" id="admin_notes" cols="30" rows="2"  placeholder="Enter teacher notes" ></textarea>
		</div>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="assignmentSubmit()">Save changes</button>
	  </div>
	</ng-template>
  </div>